export default "__VITE_ASSET__ce5a3057__"